import React, { useState, useEffect } from "react";
import { Eye, Trash2, RotateCcw, User, Briefcase } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./RegistrationStyles.css";

const url = process.env.REACT_APP_BACKEND_URL;

const JobAvailabilityList = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInactive, setShowInactive] = useState(false);
  const navigate = useNavigate();

  const fetchJobs = async () => {
    try {
      const endpoint = showInactive
        ? `${url}/api/jobavailabity/all`
        : `${url}/api/jobavailabity`;

      const res = await axios.get(endpoint);
      setJobs(res.data.data || []);
    } catch (err) {
      alert(err.response?.data?.message || "Failed to fetch job availabilities");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, [showInactive]);

  const handleSoftDelete = async (id) => {
    if (window.confirm("Are you sure you want to deactivate this job availability?")) {
      try {
        const res = await axios.delete(`${url}/api/jobavailabity/${id}`);
        alert(res.data.message || "Job availability deactivated successfully");
        fetchJobs();
      } catch (err) {
        alert(err.response?.data?.message || "Failed to deactivate job availability");
      }
    }
  };

  const handleRestore = async (id) => {
    if (window.confirm("Activate this job availability?")) {
      try {
        const res = await axios.put(`${url}/api/jobavailabity/${id}/restore`);
        alert(res.data.message || "Job availability activated successfully");
        fetchJobs();
      } catch (err) {
        alert(err.response?.data?.message || "Failed to activate job availability");
      }
    }
  };

  if (loading) return <div className="loading">Loading job availabilities...</div>;

  return (
    <div className="registration-container">
      <div className="header">
        <h2>Job Availabilities List</h2>
        <div className="header-actions">
          <button
            onClick={() => setShowInactive(!showInactive)}
            className="toggle-button"
          >
            {showInactive ? 'Show Active Only' : 'Show All'}
          </button>
          <button
            onClick={() => navigate("/registration/new")}
            className="add-button"
          >
            New Registration
          </button>
        </div>
      </div>

      <table className="registration-table">
        <thead>
          <tr>
            <th>Job No</th>
            <th>Customer</th>
            <th>Job Category</th>
            <th>Section</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {jobs.length === 0 ? (
            <tr>
              <td colSpan="6" className="no-data">
                No job availabilities found
              </td>
            </tr>
          ) : (
            jobs.map((job) => (
              <tr key={job._id}>
                <td>{job.no}</td>
                <td>
                  <div className="customer-info">
                    <User size={14} />
                    {job.customer?.fullname || 'N/A'}
                  </div>
                </td>
                <td>
                  <div className="job-info">
                    <Briefcase size={14} />
                    {job.jobname?.category_name || 'N/A'}
                  </div>
                </td>
                <td>
                  <span className={`section-badge ${job.section?.toLowerCase().replace(' ', '-')}`}>
                    {job.section}
                  </span>
                </td>
                <td>
                  <span className={`status-badge ${job.status}`}>
                    {job.status === "active" ? "Active" : "Inactive"}
                  </span>
                </td>
                <td className="actions">
                  {job.status === "active" ? (
                    <>
                      <button
                        onClick={() => navigate(`/registration/customer/${job.customer?._id}/jobs`)}
                        className="action-btn view"
                        title="View Details"
                      >
                        <Eye size={14} />
                      </button>
                      <button
                        onClick={() => handleSoftDelete(job._id)}
                        className="action-btn delete"
                        title="Deactivate"
                      >
                        <Trash2 size={14} />
                      </button>
                    </>
                  ) : (
                    <button
                      onClick={() => handleRestore(job._id)}
                      className="restore-btn"
                    >
                      <RotateCcw size={14} /> Activate
                    </button>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default JobAvailabilityList;